import navigate from '@/utils/navigate';

const env = import.meta.env || {};

const performAccountNavigation = (path) => {
  navigate(`${env.VUE_APP_NAKAMA_URL}${path}`, { external: true, newTab: true });
};

export default performAccountNavigation;
